import React from 'react';
import { IntlMessagePops } from '../providers/interface';
import { IntlMessage } from './IntlMessage';

export const getIntlMessage = (basePath: string) => (path = '', options?: IntlMessagePops): JSX.Element => (
  <IntlMessage id={`${basePath}.${path}`} {...options} />
);
